<script setup lang="ts">
import VOrderDetail from './VOrderDetail.vue';

const props = defineProps<{ orderId: string }>();
const emit = defineEmits(['on-order-list']);

const { fetchOrderDetails, currentOrder } = useOrders();

if (props.orderId) {
  await fetchOrderDetails(props.orderId);
}

const backToAllOrders = () => {
  emit('on-order-list');
};
</script>

<template>
  <div class="order-details">
    <button class="sf-button--text all-orders underline" @click="backToAllOrders">
      {{ $t('All Orders') }}
    </button>
    <VOrderDetail v-if="currentOrder" :order="currentOrder as any" />
  </div>
</template>
